import { DistributorDemoStats } from "types/analyticsTypes";

export type SortDirection = "asc" | "desc";

export function sortByDemoCount(
  distributors: DistributorDemoStats[],
  direction: SortDirection,
): DistributorDemoStats[] {
  return [...distributors].sort((a, b) => {
    const byCount = direction === "asc" ? a.demoCount - b.demoCount : b.demoCount - a.demoCount;
    return byCount !== 0 ? byCount : a.distId.localeCompare(b.distId);
  });
}
